
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M607.93,333.41A222.59,222.59,0,0,0,492.47,212.22a225.14,225.14,0,0,0-46.64-15.31l56.59-42.5A7.41,7.41,0,0,0,503.89,144L464.75,91.91a7.4,7.4,0,0,0-10.37-1.47l-115.88,87a7.66,7.66,0,0,0-.7.46l-52.12,39.14a7.41,7.41,0,0,0-1.47,10.38l125.7,167.39a7.42,7.42,0,0,0,10.38,1.47l52.12-39.14a7.4,7.4,0,0,0,1.47-10.37L418.77,273.4a144,144,0,0,1,114.8,89.52c29.23,73.65-6.92,157.35-80.57,186.57s-157.35-6.92-186.57-80.58a143.36,143.36,0,0,1-8.29-76.11l-78.94-13a223.72,223.72,0,1,0,428.73-46.42Z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM605.37,504.61A223.72,223.72,0,0,1,179.2,379.83l78.94,13a143.36,143.36,0,0,0,8.29,76.11c29.22,73.66,112.91,109.8,186.57,80.58s109.8-112.92,80.57-186.57a144,144,0,0,0-114.8-89.52l55.11,73.39a7.4,7.4,0,0,1-1.47,10.37L420.29,396.3a7.42,7.42,0,0,1-10.38-1.47L284.21,227.44a7.41,7.41,0,0,1,1.47-10.38l52.12-39.14a7.66,7.66,0,0,1,.7-.46l115.88-87a7.4,7.4,0,0,1,10.37,1.47L503.89,144a7.41,7.41,0,0,1-1.47,10.38l-56.59,42.5a225.14,225.14,0,0,1,46.64,15.31,223.71,223.71,0,0,1,112.9,292.39Z"}})])])
          )
        }
      }
    